import React from 'react';
import ButtonText from './ButtonText';

const HubspotButton = () => {

  const handleClick = () => {
    window.open(
      'https://meetings-eu1.hubspot.com/meetings/marco-stein?uuid=e8585be0-b9d4-49f4-9de1-84063c9d950e',
      '_blank'
    );
  }
  return (
    <button
      onClick={() => handleClick()}
      className="btn btn-secondary"
      style={{ width: 250 }}
    >
      <ButtonText />
    </button>
  );
};

export default HubspotButton;
